import {
  ADD_PAYMENT,
  GET_PAYMENTS,
  EDIT_PAYMENT,
  DELETE_PAYMENT,
} from "../Action/payment";

const initialState = {
  payments: [],
};

function contractReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_PAYMENT: {
      return { ...state, payments: [action.payload, ...state.payments] };
    }
    case EDIT_PAYMENT: {
      let UpdatePayment = state.payments.map((item) =>
        item.payment_id === action.payload.payment_id ? action.payload : item
      );
      return {
        ...state,
        payments: UpdatePayment,
      };
    }
    case DELETE_PAYMENT: {
      console.log(action.payload);
      const after_delete_payment = state.payments.filter(
        (payment) => payment.payment_id !== action.payload.payment_id
      );
      console.log(after_delete_payment);
      return { ...state, payments: after_delete_payment };
    }
    case GET_PAYMENTS: {
      return { ...state, payments: action.payload };
    }
    default:
      return state;
  }
}

export default contractReducer;
